const GET_BILLING_EMPLOYEES_REQUEST = 'GET_BILLING_EMPLOYEES_REQUEST';
const UPDATE_EMPLOYEE_SALARY_DATA_REQUEST = 'UPDATE_EMPLOYEE_SALARY_DATA_REQUEST';
const SET_EMPLOYEE_TERMINATED_REQUEST = 'SET_EMPLOYEE_TERMINATED_REQUEST';
const GET_EMPLOYEE_PAYMENTS_REQUEST = 'GET_EMPLOYEE_PAYMENTS_REQUEST';
const CREATE_EMPLOYEE_PAYMENT_REQUEST = 'CREATE_EMPLOYEE_PAYMENT_REQUEST';
const UPDATE_EMPLOYEE_PAYMENT_REQUEST = 'UPDATE_EMPLOYEE_PAYMENT_REQUEST';
const DELETE_EMPLOYEE_PAYMENT_REQUEST = 'DELETE_EMPLOYEE_PAYMENT_REQUEST';

export const getBillingEmployees = (callback) => ({
    type: GET_BILLING_EMPLOYEES_REQUEST,
    payload: { callback }
});

export const updateEmployeeSalaryData = (employeeId, salaryData, callback) => ({
    type: UPDATE_EMPLOYEE_SALARY_DATA_REQUEST,
    payload: { employeeId, salaryData, callback }
});

export const setEmployeeTerminated = (employeeId, terminatedAt, callback) => ({
    type: SET_EMPLOYEE_TERMINATED_REQUEST,
    payload: { employeeId, terminatedAt, callback }
});

export const getEmployeePayments = (employeeId, callback) => ({
    type: GET_EMPLOYEE_PAYMENTS_REQUEST,
    payload: { employeeId, callback }
});

export const createEmployeePayment = (employeeId, payment, callback) => ({
    type: CREATE_EMPLOYEE_PAYMENT_REQUEST,
    payload: { employeeId, payment, callback }
});

export const updateEmployeePayment = (employeeId, paymentId, payment, callback) => ({
    type: UPDATE_EMPLOYEE_PAYMENT_REQUEST,
    payload: { employeeId, paymentId, payment, callback }
});

export const deleteEmployeePayment = (employeeId, paymentId, callback) => ({
    type: DELETE_EMPLOYEE_PAYMENT_REQUEST,
    payload: { employeeId, paymentId, callback }
});
